import React from 'react'
export const buildFloatingTargetStyle = (
  coords: XYCoords | null,
): React.CSSProperties => ({
  position: 'fixed',
  zIndex: 100,
  top: coords?.y ?? -1000,
  left: coords?.x ?? -1000,
})
